export default "__VITE_ASSET__bTvmTjV0__";